import React, { useEffect, useState } from 'react';


import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import fruit from "resources/img/puffu/main/fruit.svg";
import brand from "resources/img/puffu/main/brand.svg";
import rank from "resources/img/puffu/main/rank.svg";
import giftBox from "resources/img/puffu/main/giftBox.svg";
import { useTouchClick } from "shared/hooks/useTouchClick";
import MainCategoryBtn from '../../horizontal/category/MainCategoryBtn';


function HorizontalMenuButtons({
    onBrandClick,
    onAdClick,
    onEventClick,
    onBestClick,
    onNewClick
}) {
    const [isDisabled, setIsDisabled] = useState(true); // 초기값을 true로 설정


    const { handleTouchStart: brandTouchStart, handleTouchEnd: brandTouchEnd } = useTouchClick(onBrandClick, 10);
    const { handleTouchStart: adTouchStart, handleTouchEnd: adTouchEnd } = useTouchClick(onAdClick, 10);
    const { handleTouchStart: newTouchStart, handleTouchEnd: newTouchEnd } = useTouchClick(onNewClick, 10);
    const { handleTouchStart: eventTouchStart, handleTouchEnd: eventTouchEnd } = useTouchClick(onEventClick, 10);
    const { handleTouchStart: bestTouchStart, handleTouchEnd: bestTouchEnd } = useTouchClick(onBestClick, 10);

    useEffect(() => {
        // 컴포넌트 마운트 시 0.3초 후에 isDisabled를 false로 변경
        const timer = setTimeout(() => {
            setIsDisabled(false);
        }, 300);

        // 컴포넌트 언마운트 시 타이머 정리
        return () => clearTimeout(timer);
    }, []); // 빈 배열을 넣어 마운트 시에만 실행

    return (
        <div style={{width: '93%'}}>
        <VerticalFlex gap={20}>
            <FlexChild height={"10px"} />
            <FlexChild justifyContent={"center"}>
                <HorizontalFlex gap={20}>
                    <FlexChild>
                        <MainCategoryBtn
                            onPointerDown={eventTouchStart}
                            onPointerUp={eventTouchEnd}
                            background={'linear-gradient(180deg, #FE531F 0%, #FF7171 100%'}
                            text1={'이벤트 상품'}
                            text2={'모아보기'}
                            mainCategoryImg={giftBox}
                            color={"white"}
                            // three={<GLBModelViewer />}
                            imgWidth={"90%"}
                            btnBackground={'white'}
                            btnColor={'#FE531F'}
                            vibrate={true}
                            transY={25}
                        />

                    </FlexChild>
                    <FlexChild>
                        <MainCategoryBtn
                            onPointerDown={adTouchStart}
                            onPointerUp={adTouchEnd}
                            background={'white'}
                            mainCategoryImg={fruit}
                            imgWidth={"80%"}
                            ad
                        />
                        {/* <MainCategoryBtn
                            onPointerDown={newTouchStart}
                            onPointerUp={newTouchEnd}
                            background={'linear-gradient(180deg, #FFFFFF 0%, #E9EAF7 100%)'}
                            // background={'black'}
                            text1={'새로나온 '}
                            text2={'신상 모음'}
                            // three={<GLTFModelViewer2 />}
                            mainCategoryImg={fruit}
                            imgWidth={"100%"}
                            btnBackground={'#1D43FF'}
                            btnColor={'white'}
                            vibrate={true}
                            isDisabled={isDisabled}
                            transY={10}
                        /> */}
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild>
            <FlexChild>
                <HorizontalFlex gap={20}>
                    <FlexChild>
                        <MainCategoryBtn
                            onPointerDown={brandTouchStart}
                            onPointerUp={brandTouchEnd}
                            background={'linear-gradient(180deg, #FFFFFF 0%, #E9EAF7 100%)'}
                            // background={'black'}
                            text1={'브랜드별'}
                            text2={'상품 모음'}
                            // three={<GLTFModelViewer2 />}
                            mainCategoryImg={brand}
                            imgWidth={"100%"}
                            btnBackground={'#1D43FF'}
                            btnColor={'white'}
                            vibrate={true}
                            transY={40}
                        />
                    </FlexChild>
                    <FlexChild>
                        <MainCategoryBtn
                            onPointerDown={bestTouchStart}
                            onPointerUp={bestTouchEnd}
                            background={'linear-gradient(180deg, #2D9E66 0%, #10B4A0 100%)'}
                            text1={'이번달 최다판매'}
                            text2={'인기상품'}
                            mainCategoryImg={rank}
                            color={"white"}
                            imgWidth={"100%"}
                            // three={<GLBModelViewerBest />}
                            btnBackground={'white'}
                            btnColor={'#27A373'}
                            vibrate={true}
                            isDisabled={isDisabled}
                            transY={40}
                        />
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild>
        </VerticalFlex>
        </div>
    );
};

export default HorizontalMenuButtons 